<nz-modal
  [nzVisible]="isVisible()"
  [nzTitle]="modalTitle"
  [nzWidth]="760"
  [nzFooter]="footer"
  (nzOnCancel)="onCancel()"
>
  <ng-template #modalTitle>
    <span i18n>Edit Model:</span>&nbsp;{{ model()?.version }}
  </ng-template>

  <ng-container *nzModalContent>
    <form nz-form [formGroup]="form" nzLayout="vertical">

      <nz-row [nzGutter]="16">
        <nz-col [nzSpan]="6">
          <nz-form-item>
            <nz-form-label i18n>Active</nz-form-label>
            <nz-form-control>
              <nz-switch formControlName="isActive"></nz-switch>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="6">
          <nz-form-item>
            <nz-form-label i18n>Using Delta E</nz-form-label>
            <nz-form-control>
              <nz-switch formControlName="isUsingDeltaE"></nz-switch>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="12">
          <nz-form-item>
            <nz-form-label i18n>Max CI for Reliable Prediction</nz-form-label>
            <nz-form-control>
              <nz-input-number
                formControlName="maxCi4ReliablePrediction"
                [nzMin]="0"
                [nzMax]="100"
                [nzStep]="1"
                style="width: 100%"
              ></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <nz-divider i18n-nzText nzText="Delta E Thresholds" nzOrientation="left"></nz-divider>
      <nz-row [nzGutter]="16">
        <nz-col [nzSpan]="8">
          <nz-form-item>
            <nz-form-label>dE</nz-form-label>
            <nz-form-control>
              <nz-input-number
                formControlName="deThreshold"
                [nzMin]="0"
                [nzMax]="100"
                [nzStep]="0.1"
                style="width: 100%"
              ></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="8">
          <nz-form-item>
            <nz-form-label>dC</nz-form-label>
            <nz-form-control>
              <nz-input-number
                formControlName="dcThreshold"
                [nzMin]="0"
                [nzMax]="100"
                [nzStep]="0.1"
                style="width: 100%"
              ></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="8">
          <nz-form-item>
            <nz-form-label>xdE</nz-form-label>
            <nz-form-control>
              <nz-input-number
                formControlName="xdeThreshold"
                [nzMin]="0"
                [nzMax]="100"
                [nzStep]="0.1"
                style="width: 100%"
              ></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <nz-divider i18n-nzText nzText="In a Bucket" nzOrientation="left"></nz-divider>
      <nz-row [nzGutter]="16">
        <nz-col [nzSpan]="4">
          <nz-form-item>
            <nz-form-label i18n>ΔL Max</nz-form-label>
            <nz-form-control>
              <nz-input-number formControlName="dlMaxThreshold" [nzMin]="-100" [nzMax]="100" [nzStep]="0.1" style="width: 100%"></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="4">
          <nz-form-item>
            <nz-form-label i18n>ΔL Min</nz-form-label>
            <nz-form-control>
              <nz-input-number formControlName="dlMinThreshold" [nzMin]="-100" [nzMax]="100" [nzStep]="0.1" style="width: 100%"></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="4">
          <nz-form-item>
            <nz-form-label i18n>ΔA Max</nz-form-label>
            <nz-form-control>
              <nz-input-number formControlName="daMaxThreshold" [nzMin]="-100" [nzMax]="100" [nzStep]="0.1" style="width: 100%"></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="4">
          <nz-form-item>
            <nz-form-label i18n>ΔA Min</nz-form-label>
            <nz-form-control>
              <nz-input-number formControlName="daMinThreshold" [nzMin]="-100" [nzMax]="100" [nzStep]="0.1" style="width: 100%"></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="4">
          <nz-form-item>
            <nz-form-label i18n>ΔB Max</nz-form-label>
            <nz-form-control>
              <nz-input-number formControlName="dbMaxThreshold" [nzMin]="-100" [nzMax]="100" [nzStep]="0.1" style="width: 100%"></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="4">
          <nz-form-item>
            <nz-form-label i18n>ΔB Min</nz-form-label>
            <nz-form-control>
              <nz-input-number formControlName="dbMinThreshold" [nzMin]="-100" [nzMax]="100" [nzStep]="0.1" style="width: 100%"></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <nz-divider i18n-nzText nzText="Across Buckets" nzOrientation="left"></nz-divider>
      <nz-row [nzGutter]="16">
        <nz-col [nzSpan]="4">
          <nz-form-item>
            <nz-form-label i18n>ΔL Max</nz-form-label>
            <nz-form-control>
              <nz-input-number formControlName="crossDLMaxThreshold" [nzMin]="-100" [nzMax]="100" [nzStep]="0.1" style="width: 100%"></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="4">
          <nz-form-item>
            <nz-form-label i18n>ΔL Min</nz-form-label>
            <nz-form-control>
              <nz-input-number formControlName="crossDLMinThreshold" [nzMin]="-100" [nzMax]="100" [nzStep]="0.1" style="width: 100%"></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="4">
          <nz-form-item>
            <nz-form-label i18n>ΔA Max</nz-form-label>
            <nz-form-control>
              <nz-input-number formControlName="crossDAMaxThreshold" [nzMin]="-100" [nzMax]="100" [nzStep]="0.1" style="width: 100%"></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="4">
          <nz-form-item>
            <nz-form-label i18n>ΔA Min</nz-form-label>
            <nz-form-control>
              <nz-input-number formControlName="crossDAMinThreshold" [nzMin]="-100" [nzMax]="100" [nzStep]="0.1" style="width: 100%"></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="4">
          <nz-form-item>
            <nz-form-label i18n>ΔB Max</nz-form-label>
            <nz-form-control>
              <nz-input-number formControlName="crossDBMaxThreshold" [nzMin]="-100" [nzMax]="100" [nzStep]="0.1" style="width: 100%"></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="4">
          <nz-form-item>
            <nz-form-label i18n>ΔB Min</nz-form-label>
            <nz-form-control>
              <nz-input-number formControlName="crossDBMinThreshold" [nzMin]="-100" [nzMax]="100" [nzStep]="0.1" style="width: 100%"></nz-input-number>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <nz-divider i18n-nzText nzText="Description" nzOrientation="left"></nz-divider>
      <nz-form-item>
        <nz-form-label i18n>Description (Supports Markdown)</nz-form-label>
        <nz-form-control>
          <textarea
            nz-input
            formControlName="description"
            [nzAutosize]="{ minRows: 4, maxRows: 12 }"
            style="width: 100%"
          ></textarea>
        </nz-form-control>
      </nz-form-item>

    </form>
  </ng-container>

  <ng-template #footer>
    <button nz-button nzType="default" (click)="onCancel()" i18n>Cancel</button>
    <button nz-button nzType="primary" [nzLoading]="saving()" (click)="onSave()" i18n>Save</button>
  </ng-template>
</nz-modal>
